var _rect, _path, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 36,
    viewBox: "0 0 68 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 58,
    height: 32,
    rx: 3,
    stroke: "black",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 13H63C64.6569 13 66 14.3431 66 16V20C66 21.6569 64.6569 23 63 23H60V13Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 9.5,
    width: 3,
    height: 17,
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 9.5,
    width: 3,
    height: 17,
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 9.5,
    width: 3,
    height: 17,
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 9.5,
    width: 3,
    height: 17,
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBat);
export default __webpack_public_path__ + "static/media/bat.c899f216c52fec69d1afdd36a186a367.svg";
export { ForwardRef as ReactComponent };